// 接口域名按环境取自 .env.* 中的 VUE_APP_API_BASE_URL
// development → .env.development（npm run serve）
// testing     → .env.testing（npm run build:test）
// production  → .env.production（npm run build）
export const APP_ENV = process.env.VUE_APP_ENV || 'development'
export const API_BASE_URL = String(process.env.VUE_APP_API_BASE_URL || '').replace(/\/$/, '')
